import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { Phone, Mail, Clock } from 'lucide-react';
export function AppointmentPage() {
  return <div className="flex flex-col w-full" data-id="element-140">
      <HeroBanner title="REQUEST AN ESTIMATE" subtitle="Fill out the form below and our team will contact you to schedule a free, no-obligation estimate." data-id="element-141" />

      <section className="py-20 px-4 bg-slate-50" data-id="element-142">
        <div className="max-w-7xl mx-auto" data-id="element-143">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-144">
            {/* Form Area */}
            <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-200 p-8 sm:p-10" data-id="element-145">
              <h2 className="text-2xl font-bold text-[#0c2340] mb-8" data-id="element-146">
                Project Details
              </h2>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-147">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-148">
                  <div className="space-y-2" data-id="element-149">
                    <label htmlFor="firstName" className="block text-sm font-medium text-slate-700" data-id="element-150">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="John" data-id="element-151" />
                  </div>
                  <div className="space-y-2" data-id="element-152">
                    <label htmlFor="lastName" className="block text-sm font-medium text-slate-700" data-id="element-153">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="Doe" data-id="element-154" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-155">
                  <div className="space-y-2" data-id="element-156">
                    <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-157">
                      Email Address
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="john@example.com" data-id="element-158" />
                  </div>
                  <div className="space-y-2" data-id="element-159">
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-700" data-id="element-160">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="(714) 555-0123" data-id="element-161" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-162">
                  <label htmlFor="address" className="block text-sm font-medium text-slate-700" data-id="element-163">
                    Property Address
                  </label>
                  <input type="text" id="address" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="123 Main St, City, Zip" data-id="element-164" />
                </div>

                <div className="space-y-2" data-id="element-165">
                  <label htmlFor="service" className="block text-sm font-medium text-slate-700" data-id="element-166">
                    Service Needed
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow bg-white" data-id="element-167">
                    <option value="" data-id="element-168">Select a service...</option>
                    <option value="new-install" data-id="element-169">New Gutter Installation</option>
                    <option value="replacement" data-id="element-170">Gutter Replacement</option>
                    <option value="guards" data-id="element-171">
                      Gutter Guards / Leaf Protection
                    </option>
                    <option value="repair" data-id="element-172">Gutter Repair</option>
                    <option value="cleaning" data-id="element-173">Maintenance / Cleaning</option>
                    <option value="other" data-id="element-174">Other</option>
                  </select>
                </div>

                <div className="space-y-2" data-id="element-175">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700" data-id="element-176">
                    Additional Details
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow resize-none" placeholder="Tell us about your project..." data-id="element-177"></textarea>
                </div>

                <button type="submit" className="w-full bg-[#0c2340] hover:bg-[#0a1c33] text-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-178">
                  Submit Request
                </button>
              </form>
            </div>

            {/* Sidebar Info */}
            <div className="space-y-8" data-id="element-179">
              <div className="bg-[#0c2340] rounded-2xl p-8 text-white" data-id="element-180">
                <h3 className="text-xl font-bold mb-6" data-id="element-181">Contact Information</h3>
                <ul className="space-y-6" data-id="element-182">
                  <li className="flex items-start gap-4" data-id="element-183">
                    <Phone className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-184" />
                    <div data-id="element-185">
                      <p className="font-semibold mb-1" data-id="element-186">Call Us Directly</p>
                      <a href="tel:7146023634" className="text-slate-300 hover:text-white transition-colors" data-id="element-187">
                        (714) 602-3634
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-188">
                    <Mail className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-189" />
                    <div data-id="element-190">
                      <p className="font-semibold mb-1" data-id="element-191">Email Us</p>
                      <a href="mailto:info@aflowraingutters.com" className="text-slate-300 hover:text-white transition-colors" data-id="element-192">
                        info@aflowraingutters.com
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-193">
                    <Clock className="w-6 h-6 text-[#b87333] shrink-0" data-id="element-194" />
                    <div data-id="element-195">
                      <p className="font-semibold mb-1" data-id="element-196">Business Hours</p>
                      <p className="text-slate-300" data-id="element-197">
                        Mon - Fri: 8:00 AM - 5:00 PM
                      </p>
                      <p className="text-slate-300" data-id="element-198">Sat - Sun: Closed</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-8 border border-slate-200" data-id="element-199">
                <h3 className="text-lg font-bold text-[#0c2340] mb-3" data-id="element-200">
                  What happens next?
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-201">
                  After you submit this form, our team will review your details
                  and contact you within 1 business day to schedule an on-site
                  evaluation. We'll take precise measurements and provide a
                  detailed, written estimate for your project.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}